if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

onSubmitHandler(evt) {
  evt.preventDefault();
  if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

  this.handleErrorMessage();

  this.submitButton.setAttribute('aria-disabled', true);
  this.submitButton.classList.add('loading');
  this.querySelector('.loading__spinner').classList.remove('hidden');

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  const formData = new FormData(this.form);

  /* --------------------------------------------
     🔥 UPSSELL INJECTION (LA CLÉ)
  -------------------------------------------- */

  const upsellCard = document.querySelector('[data-upsell-card]');
  const upsellCheckbox = upsellCard?.querySelector('[data-upsell-checkbox]');
  const upsellVariantId = Number(upsellCard?.dataset.upsellVariantId);

  if (upsellCheckbox && upsellCheckbox.checked && upsellVariantId) {
    const mainVariantId = Number(formData.get('id'));
    const quantity = Number(formData.get('quantity') || 1);

    // supprimer les champs racine
    formData.delete('id');
    formData.delete('quantity');

    // récupérer les properties du produit principal
    const properties = {};
    for (const [key, value] of formData.entries()) {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match && value) properties[match[1]] = value;
    }

    // nettoyer les anciennes properties
    Object.keys(properties).forEach((k) => {
      formData.delete(`properties[${k}]`);
    });

    // item principal
    formData.append('items[0][id]', mainVariantId);
    formData.append('items[0][quantity]', quantity);

    Object.entries(properties).forEach(([k, v]) => {
      formData.append(`items[0][properties][${k}]`, v);
    });

    // upsell
    formData.append('items[1][id]', upsellVariantId);
    formData.append('items[1][quantity]', 1);
  }

  /* -------------------------------------------- */

  if (this.cart) {
    formData.append(
      'sections',
      this.cart.getSectionsToRender().map((section) => section.id)
    );
    formData.append('sections_url', window.location.pathname);
    this.cart.setActiveElement(document.activeElement);
  }

  config.body = formData;

  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          errors: response.errors || response.description,
          message: response.message,
        });
        this.handleErrorMessage(response.description);
        this.error = true;
        return;
      }

      const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'product-form',
        productVariantId: response.id,
        cartData: response,
      }).then(() => {
        CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
      });

      const quickAddModal = this.closest('quick-add-modal');
      if (quickAddModal) {
        quickAddModal.hide(true);
      } else {
        this.cart.renderContents(response);
      }
    })
    .catch(console.error)
    .finally(() => {
      this.submitButton.classList.remove('loading');
      if (this.cart?.classList.contains('is-empty')) {
        this.cart.classList.remove('is-empty');
      }
      this.submitButton.removeAttribute('aria-disabled');
      this.querySelector('.loading__spinner').classList.add('hidden');
    });
}


      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
